// src/context/ClientContext.js
import React, { createContext, useState } from 'react';

export const ClientContext = createContext();

export const ClientProvider = ({ children }) => {
  const [clientData, setClientData] = useState(null);
  const [clientStatus, setClientStatus] = useState(null);
  const [clientAuthorization, setClientAuthorization] = useState(null);
  const [clientException, setClientException] = useState(null);

  const value = {
    clientData,
    setClientData,
    clientStatus,
    setClientStatus,
    clientAuthorization,
    setClientAuthorization,
    clientException,
    setClientException,
  };

  return (
    <ClientContext.Provider value={value}>
      {children}
    </ClientContext.Provider>
  );
};
